import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { BlacklistMutationKeys } from '../../../keys'
import { deleteBlacklistReport } from '../../services'

interface UseMutationDeleteBlacklistReportProps {
	id: string
}

export default function useMutationDeleteBlacklistReport(
	props?: UseBaseMutationOptions<void, UseMutationDeleteBlacklistReportProps>,
) {
	return useMutation({
		mutationKey: [BlacklistMutationKeys.DeleteBlacklistReport],
		mutationFn: ({ id }) => deleteBlacklistReport(id),
		...props,
	})
}
